import RHFDictionary from '../RHFDictionary';
import { useProcurementSuppliers } from 'iomart-hooks';
import type { Columns } from 'src/@types/common';

const DICTIONARY_COLUMNS: (Columns & { minWidth?: number; maxWidth?: number })[] = [
  {
    name: 'name',
    subname: 'contactName',
    label: 'Name',
    align: 'left',
    nameLines: 1,
    subNameLines: 1,
    minWidth: 160,
    width: 220,
    maxWidth: 220,
  },
  {
    name: 'countryCode',
    label: 'Country',
    align: 'center',
    width: 80,
    minWidth: 70,
    maxWidth: 90,
  },
  {
    name: 'email',
    subname: 'phone',
    subFormat: 'phone',
    label: 'Email / Phone',
    align: 'left',
    nameLines: 1,
    minWidth: 140,
    width: 180,
    maxWidth: 220,
  }
];

type RHFProcurementSuppliersProps = {
  name: string;
  label?: string;
  multiple?: boolean;
  disabled?: boolean;
  /** Фильтр по коду страны (ISO) */
  countryCode?: string;
  /** Ширина Drawer справочника */
  drawerWidth?: Record<string, string | number>;
};

export default function RHFProcurementSuppliers({
  name,
  label = 'Supplier',
  multiple = false,
  disabled,
  countryCode,
  drawerWidth = { xs: '100%', sm: 560 },
}: RHFProcurementSuppliersProps) {
  const filters = countryCode != null ? { countryCode } : {};
  const appliedReferenceFilters =
    countryCode != null ? [{ key: 'countryCode', label: 'Country' }] : [];

  return (
    <RHFDictionary
      name={name}
      label={label}
      useHook={useProcurementSuppliers}
      columns={DICTIONARY_COLUMNS}
      multiple={multiple}
      optionsLabel="name"
      getOptionLabel={(opt: any) => opt?.name || `#${opt?.id}` || ''}
      searchName="search"
      pageSize={10}
      disabled={disabled}
      filters={filters}
      appliedReferenceFilters={appliedReferenceFilters}
      drawerWidth={drawerWidth}
    />
  );
}
